import { makeStyles } from "@material-ui/core";

const useNavBarStyles = makeStyles(theme => ({
    root: {
        size: "50px",
        fontWeight: "48px"
    },
    menuicon: {
        width: "26px",
        height: "25px",
        show: true,
        clickable: true,
    },
    actionIconsToolBar: {
        //width: '60%',
        justifyContent: 'flex-end',
        paddingRight: 12,
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center'
    },
    appBar: {
        display: "flex",
        flexDirection: "row",
        backgroundColor: theme.palette.common.white,
        height: "3.125rem",
        color: '#354052',
        zIndex: theme.zIndex.navDrawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toolBar: {
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: "10px",
        minHeight: "50px",

    },
    title: {
        display: "inline-flex"
    },
    header: {
        fontFamily: "'Oswald', sans-serif",
        fontSize: "1.15rem",
        color: "#354052",
        display: "flex",
        alignItems: "center",
        paddingLeft: "1rem",
        flexGrow: 1,
        fontWeight: 400
    },
    subheader: {
        fontFamily: "'Oswald', sans-serif",
        fontSize: "20px !important",
        fontWeight: "400",
        color: "#000 !important",
        padding: "0px 5px"
    },
    productTitle: {
        color: '#0098F3 !important'
    },
    textureRoot: {
        border: '0px',
        padding: '0px',
        height: '5px',
        position: 'relative'
    },
    AppBarTexture: {
        width: '100%',
        margin: 0,
        padding: 0,
        height: '18px',
        position: 'static'
    }
}))

export default useNavBarStyles;


export const enhanceMenu = makeStyles(theme => ({
    lrPad: {
        padding: "0 0.5rem",
    },
    rightIcons: {
        display: "flex",
        alignSelf: "center",
        justifyContent: "center",
        width: "3rem",
    }
}))